/* ============================================================
   AGC NAV — behavior de la barra única (morph pill + cycle + cart)
   Auto-init. Self-contained. Replica la lógica del configurador.
   Expone window.AGCNav { open, close, toggle, isOpen } y dispara
   el evento 'agcn:toggle' (detail.open) para que otras capas
   (configurador: isla, color pill, cart-morph) reaccionen.
   Hook opcional del carrito: window.AGCNavCart() → si devuelve true,
   se cancela la navegación a /cart (el host maneja el click).
   ============================================================ */
(function () {
  'use strict';
  /* idempotente: en la PDP el script se incluye 2× (configurador + landing embebido). Sin este guard
     el menuBtn recibe 2 handlers → un click abre y cierra en el mismo tick (el menú "no abre"). */
  if (window.__agcNavBound) return;
  window.__agcNavBound = true;
  var root = document.querySelector('.agcn-root');
  if (!root) { window.__agcNavBound = false; return; }
  var nav = root.querySelector('[data-agcn-nav]');
  var bg = root.querySelector('[data-agcn-bg]');
  var menuBtn = root.querySelector('[data-agcn-menu]');
  var cartBtn = root.querySelector('.agcn-cartbtn');
  if (!nav) return;

  var cycleTimer = null, cycleIdx = 0;
  function startCycle() {
    var imgs = root.querySelectorAll('[data-agcn-cycle] img');
    if (!imgs.length || cycleTimer) return;
    cycleTimer = setInterval(function () {
      imgs[cycleIdx].classList.remove('on');
      cycleIdx = (cycleIdx + 1) % imgs.length;
      imgs[cycleIdx].classList.add('on');
    }, 2600);
  }
  function stopCycle() { if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; } }

  function setOpen(open) {
    if (nav.classList.contains('open') === open) return;
    nav.classList.toggle('open', open);
    if (bg) bg.classList.toggle('show', open);
    document.documentElement.classList.toggle('agcn-open', open); /* otras capas (isla) reaccionan a esto */
    if (open) startCycle(); else stopCycle();
    try { document.dispatchEvent(new CustomEvent('agcn:toggle', { detail: { open: open } })); } catch (e) {}
  }

  if (menuBtn) menuBtn.addEventListener('click', function (e) {
    e.preventDefault();
    setOpen(!nav.classList.contains('open'));
  });
  if (bg) bg.addEventListener('click', function () { setOpen(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });

  /* carrito: si el host registró un handler (cart-morph del configurador), lo usa */
  if (cartBtn) cartBtn.addEventListener('click', function (e) {
    setOpen(false);
    if (typeof window.AGCNavCart === 'function') {
      var handled = window.AGCNavCart();
      if (handled) e.preventDefault();
    }
  });

  /* contador de carrito */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
    root.querySelectorAll('[data-agcn-count]').forEach(function (el) { el.textContent = c.item_count; });
  }).catch(function () {});

  /* API pública */
  window.AGCNav = {
    open: function () { setOpen(true); },
    close: function () { setOpen(false); },
    toggle: function () { setOpen(!nav.classList.contains('open')); },
    isOpen: function () { return nav.classList.contains('open'); }
  };
})();
